export default __webpack_public_path__ + "static/media/tutorial-step2.a5699d24.png";